import React from 'react'
import { Switch } from '@mui/material'
import { useAbleStatusToggle } from 'hooks'
import {
  useToggleFunctionAbleMutation as mutation,
  successSnack,
} from 'features'
import { useDispatch } from 'react-redux'

//TODO migrate to use hook

/**
 * Display the student's assets and button to define or change them in a grid cell
 * @param {object} params - The param object from the Mui DataGrid column definition
 * @returns {ReactComponentElement} - component with ammount format and button to toggle set assets dialog
 */
export const GridActionFunctionSwitchEnable = ({ id, able }) => {
  const dispatch = useDispatch()

  const [toggleAbleStatus] = useAbleStatusToggle({
    id: id,
    able: able,
    mutation: mutation,
    successMessage: 'La función ha sido',
    successCallback: (response) => {
      if (response?.message === 'status_updated') {
        dispatch(
          successSnack({
            message:
              'La función ha sido ' + (!able ? 'habilitado' : 'deshabilitado'),
          })
        )
      }
      return true
    },
  })

  function handleChange(e) {
    e.preventDefault()
    e.stopPropagation()
    toggleAbleStatus(able)
  }

  return (
    <Switch
      checked={able}
      onClick={(e) => {
        handleChange(e)
      }}
    />
  )
}
